// Api Base Url

export const BaseUrl = "https://api.pillarshub.com";
export const BaseUrlNew = "http://localhost:7200/";
